<mat-form-field [appearance]="appearance()" [class]="class()" [ngClass]="{ 'mat-form-field-invalid' : showValidationError(), 'ng-invalid' : showValidationError() , 'nationality-input-none': appearance() === 'none' }" class="flex-1">
  @if (label()) {
    <mat-label>{{label()}}</mat-label>
  }
  <div matSuffix="" class="flex items-center">
    @if (isLoadingNationalities === true) {
      <mat-spinner diameter="14" class="mx2"></mat-spinner>
    }
  </div>
  @if (showPlaceholder()) {
    <span class="placeholder">
      {{control().value != null ? control().value.name : "..."}}
    </span>
  }
  <input [formControl]="control()" type="text" matInput="" [matAutocomplete]="nationalityAutoComplete" [attr.cdkFocusInitial]="focus() !== false ? 'true' : null" autocomplete="off">
  <mat-autocomplete autoActiveFirstOption="" #nationalityAutoComplete="matAutocomplete" [displayWith]="displayWithNationality">
    <mat-option [value]="null">
      <span translate="">None</span>
    </mat-option>
    @for (nationality of nationalitiesFiltered; track nationality) {
      <mat-option [value]="nationality">
        {{nationality.name}}
      </mat-option>
    }
  </mat-autocomplete>
</mat-form-field>